import useTimelineEntries from "@cosine/composables/useTimelineEntries";
import { TimelineEntrySources } from "@cosine/types/api-models";
import { defineStore } from "pinia";

export default defineStore("TimelineChatStore", () => {
  return useTimelineEntries({
    sources: [TimelineEntrySources.User],
  });
});
